import React from 'react';
import Warranty from 'components/DataFieldManager/Warranty/Warranty';
import Updating from 'components/DataFieldManager/Updating';
import { Span, Wrapper } from 'components';
import { findWarrantyField } from './restrictionUtils';

export default function WarrantyRestriction({
	orderId,
	data,
	metadata,
	isFetching,
	onChanged,
}) {
	if (isFetching) return <Updating />;
	const field = findWarrantyField(data);
	if (!field) return <Span disabled>No disponible para esta orden</Span>;

	return (
		<Wrapper padding='0' width='auto'>
			<Warranty
				key={`${orderId}:${String(field.value)}`}
				field={field}
				rowData={{
					id: orderId,
					isBilled: metadata?.eventProps?.billed,
					[field.id]: field.value,
				}}
				onChanged={() => onChanged(orderId)}
			/>
		</Wrapper>
	);
}
